import "./index.css";
import { Box, Circle, Flex, Avatar, Button, Text } from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import { useMediaQuery } from "@chakra-ui/media-query";
// import dayjs from "dayjs"
import { RiMenu2Fill } from "react-icons/ri";
import { Cards } from "./components/Cards";
import { FaFire } from "react-icons/fa";
import { IoWaterOutline } from "react-icons/io5";
import { BsLightbulb, BsBell, BsPhone } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { electricityData, waterData, gasData } from "../Electricity";
import { useDispatch, useSelector } from "react-redux";
import {
  toggleState,
  updateBrandColor,
} from "../../store/actions/displayAction";
import { UserProfileContext } from "../../context/UserContext";
import { getResolvedUserType, USER_TYPES } from "../../utils/userRole";
import RightControls from "./RightControls";

export const Navigation = ({ toggle, showSidebar }) => {
  const [currentView, setCurrentView] = useState("water");
  const [isMobile] = useMediaQuery("(max-width: 600px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userProfile, notifications, activeAccount } =
    useContext(UserProfileContext) || {};
  const isVtuActive =
    activeAccount?.type === "vtu" ||
    (!activeAccount && getResolvedUserType(userProfile) === USER_TYPES.VTU_USER);
  const pageColor = useSelector(
    (state) => state?.switchTab?.currentDisplay?.pageColor,
  );

  let effectiveProfile = userProfile || {};
  if (activeAccount?.type === "estate") {
    const estates = Array.isArray(userProfile?.estates)
      ? userProfile.estates
      : [];
    const match = estates.find(
      (e) =>
        String(e?.estateId?._id || e?.estateId) ===
        String(activeAccount.estateId),
    );
    if (match) {
      effectiveProfile = {
        ...userProfile,
        streetId: { estateId: match.estateId || match },
      };
    }
  }

  const unReadNotifications = notifications?.filter(
    (notification) => notification?.isRead === false,
  );

  const updateState = (obj, view) => {
    dispatch(toggleState({ ...obj }));
    const color =
      view?.toLowerCase() === "water"
        ? effectiveProfile?.streetId?.estateId?.colorSetting?.water
        : view?.toLowerCase() === "power"
          ? effectiveProfile?.streetId?.estateId?.colorSetting?.electricity
          : view?.toLowerCase() === "vtu"
            ? "#072F64"
            : effectiveProfile?.streetId?.estateId?.colorSetting?.gas;
    dispatch(updateBrandColor(color));
    setCurrentView(view);
    navigate("/dashboard");
  };

  const handleToggle = () => {
    if (typeof toggle === "function") toggle();
  };

  return (
    <Box position="relative">
      <Box
        className="navigation-inner"
        fontSize={{ sm: ".9em", md: ".9em", lg: "1em" }}
        px="20px"
      >
        <Box
          display="flex"
          padding="15px 10px"
          alignItems="center"
          maxW={"100%"}
          w={"100%"}
          position={"relative"}
          justifyContent={"space-between"}
        >
          <Flex flex="1" alignItems="center" minWidth={0}>
            <Box className="toggle-side-bar" mr="10px">
              {showSidebar && (
                <RiMenu2Fill
                  onClick={handleToggle}
                  size={30}
                  style={{ cursor: "pointer", paddingLeft: "10px" }}
                />
              )}
            </Box>

            {!isVtuActive &&
              (() => {
                const DEFAULT_ALLOWED_COMMODITIES = [
                  "water",
                  "electricity",
                  "gas",
                ];
                const fromEstate =
                  effectiveProfile?.streetId?.estateId?.allowedCommodities;
                const allowed =
                  Array.isArray(fromEstate) && fromEstate.length > 0
                    ? [
                        ...new Set(
                          fromEstate
                            .map((c) => String(c).trim().toLowerCase())
                            .filter((c) =>
                              DEFAULT_ALLOWED_COMMODITIES.includes(c),
                            ),
                        ),
                      ]
                    : DEFAULT_ALLOWED_COMMODITIES;

                return (
                  <Box
                    className="commodities-wrap"
                    key="commodities"
                    display="flex"
                    flexDirection={"row"}
                    alignItems={isMobile ? "center" : "center"}
                    mr="15px"
                    sx={{
                      overflowX: isMobile ? "auto" : "auto",
                      WebkitOverflowScrolling: "touch",
                      whiteSpace: isMobile ? "nowrap" : "nowrap",
                      gap: isMobile ? "8px" : "12px",
                    }}
                    minWidth={0}
                  >
                    {allowed.map((commodity) => {
                      const commonProps = {
                        key: commodity,
                        mr: 0,
                        cursor: "pointer",
                        display: "inline-block",
                        onClick:
                          commodity === "water"
                            ? () => updateState(waterData, "water")
                            : commodity === "electricity"
                              ? () => updateState(electricityData, "power")
                              : () => updateState(gasData, "gas"),
                      };

                      if (commodity === "water") {
                        return (
                          <Box {...commonProps}>
                            <Cards
                              currentView={currentView === "water"}
                              text="Water"
                              icon={<IoWaterOutline color="primary.500" size={18} />}
                              iconOnly={isMobile}
                            />
                          </Box>
                        );
                      }

                      if (commodity === "electricity") {
                        return (
                          <Box {...commonProps}>
                            <Cards
                              currentView={currentView === "power"}
                              text="Electricity"
                              icon={<BsLightbulb color="primary.500" size={18} />}
                              iconOnly={isMobile}
                            />
                          </Box>
                        );
                      }

                      if (commodity === "gas") {
                        return (
                          <Box {...commonProps}>
                            <Cards
                              currentView={currentView === "gas"}
                              text="Gas"
                              icon={<FaFire color="primary.500" size={18} />}
                              iconOnly={isMobile}
                            />
                          </Box>
                        );
                      }

                      return null;
                    })}
                  </Box>
                );
              })()}

            {/* <Box
              mr="15px"
              minW={isMobile ? "40px" : ["110px", "130px", "150px"]}
              cursor="pointer"
              display={"inline-block"}
              onClick={() => {
                setCurrentView("vtu");
                dispatch(updateBrandColor("#072F64"));
                navigate("/vtu");
              }}
            >
              <Cards
                currentView={currentView === "vtu"}
                text="VTU"
                icon={<BsPhone color="primary" size={18} />}
                iconOnly={isMobile}
              />
            </Box> */}
          </Flex>

          {!isMobile && (
            <RightControls
              isMobile={isMobile}
              pageColor={pageColor}
              userProfile={userProfile}
              unReadNotifications={unReadNotifications}
              navigate={navigate}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};
